import { LicenseValidityChooserRelativeDurationConstraint } from './license-validity-chooser-relative-duration-constraint';

export interface LicenseValidityChooserDurationConstraints<T = Date> {
  endBeforeRelativeDate: LicenseValidityChooserRelativeDurationConstraint | null;
  endBeforeDate: T | null;
}
